
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/covid-ready/compliance",
      function () {
        return require("private-next-pages/covid-ready/compliance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/covid-ready/compliance"])
      });
    }
  